import { t } from "i18next"
import logo from "./assets/logo.svg"
import BurgerMenu from "./BurgerMenu"
import { LocalOverlay } from "./localOverlays"
import { CollarStyle, MapProjection, Basemap } from "./Map"
import "./Header.css"

function Header({
  overlays,
  setOverlays,
  collarStyle,
  setCollarStyle,
  projection,
  setProjection,
  basemap,
  setBasemap,
  collarOpacity,
  setCollarOpacity,
}: {
  overlays: LocalOverlay[]
  setOverlays: React.Dispatch<React.SetStateAction<LocalOverlay[]>>
  collarStyle: CollarStyle
  setCollarStyle: React.Dispatch<React.SetStateAction<CollarStyle>>
  projection: MapProjection
  setProjection: React.Dispatch<React.SetStateAction<MapProjection>>
  basemap: Basemap
  setBasemap: React.Dispatch<React.SetStateAction<Basemap>>
  collarOpacity: number
  setCollarOpacity: React.Dispatch<React.SetStateAction<number>>
}) {
  return (
    <header className="Header">
      <a href={t("homepageUrl")}>
        <img src={logo} alt="logo" className="HeaderLogo" />
      </a>
      <h1>{t("grazingMap")}</h1>
      <BurgerMenu
        overlays={overlays}
        setOverlays={setOverlays}
        collarStyle={collarStyle}
        setCollarStyle={setCollarStyle}
        projection={projection}
        setProjection={setProjection}
        basemap={basemap}
        setBasemap={setBasemap}
        collarOpacity={collarOpacity}
        setCollarOpacity={setCollarOpacity}
      />
    </header>
  )
}

export default Header
